import { IconButton, Spacer, SvgNotes } from '@loomhq/lens';
import anime from 'animejs';
import classNames from 'classnames';
import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { showConfirmationModal } from 'actions/confirmationModal';
import { showErrorBar } from 'actions/errorBar';
import { updateLoginOrSignUp } from 'actions/login';
import { updateNotificationSettings } from 'actions/notification-settings';
import {
  updateShareVideo,
  updateShareVideoInTrimMode,
  updateShareVideoPassword,
  updateShareVideoShowRemoveModal,
  updateVideoCtaShow,
  updateVideoIframeVisibility,
} from 'actions/shareVideo';
import { showStatusBar } from 'actions/statusBar';
import { toggleTranscriptVisible } from 'actions/videoPlayer';
import { toggleViewerInsightsUI } from 'actions/viewerInsights';
import {
  LARGE_TABLET_MAX_WIDTH,
  LARGE_TABLET_MIN_WIDTH,
  SMALL_TABLET_MAX_WIDTH,
  TABLET_MIN_WIDTH,
} from 'constants/breakpoints';
import {
  ENTERED_TRIM_MODE,
  NEW_ONBOARDING_EXISTING_USER_COMPLETE,
  PUSH_NOTIFICATION_PROMPT_ACCEPTED,
  PUSH_NOTIFICATION_PROMPT_DISMISSED,
  TRANSCRIPTION_CLOSE_OUT,
} from 'constants/events';
import { VIDEO_DURATION } from 'constants/limits';
import {
  EMBED_DIMENSIONS_UPDATE,
  EMBED_VIDEO_CORRECT_PASS,
  EMBED_VIDEO_DURATION,
  EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED,
  EXTENSION_CLICKED,
} from 'constants/messages';
import { PUSH_ACTIVATION_SETTINGS } from 'constants/notifications';
import { LOOM_URI, ROOT_PAGE, WELCOME } from 'constants/routes';
import {
  RECORDING_TIMER_PAYWALL,
  VIDEO_EDIT_OPTIONS_ACCESS,
  VIDEO_TOOLS_ACCESS,
} from 'constants/scopes';
import {
  NEW_ONBOARDING_EXISTING_USER,
  REQUEST_PUSH_PERMISSIONS,
} from 'constants/triggers';
import { getFeatureFlagCreator } from 'creators/featureFlag';
import { fetchGoogleInfoCreator } from 'creators/google';
import { postNotificationSettings } from 'creators/notification-settings';
import {
  fetchShareVideoDownloadUrlCreator,
  fetchVideoCreator,
  handleToggleTranscriptCreator,
  subscribeToGif,
  updateVideoNameCreator,
} from 'creators/shareVideo';
import { completeTriggerCreator } from 'creators/triggers';
import { enterTrimModeCreator } from 'creators/trimming';
import { postVerifyEmail } from 'creators/user';
import { sendInactiveVideoOwnerPing } from 'creators/videoPlayer';
import * as analytics from 'utilities/analytics';
import { getCloudfrontURI } from 'utilities/avatar';
import * as clipboard from 'utilities/clipboard';
import * as device from 'utilities/device';
import * as extension from 'utilities/extension';
import * as jqueryExt from 'utilities/jqueryExt';
import { getParam, goToNewTab } from 'utilities/url';

import loomLinkCopiedIconSrc from 'img/icons/loom-link-copied.svg';
import { useWorkspaceLimit } from 'hooks/useWorkspaceLimit';
import { hasScope } from 'selectors/scopes';
import {
  selectDrawSharepageControlBar,
  selectUserCanEditVideo,
} from 'selectors/shareVideo';
import { selectIsActive as viewerInsightsActive } from 'selectors/viewerInsights';

import AttachmentUploadProgressModal from './attachment-upload-progress-modal';
import AttachmentsBar from './attachments-bar';
import Comments from './comments';
import ContentLimitPaywallModal from './content-limit-paywall-modal';
import ShareVideoControlBar from './control-bar';
import CustomCtaButton from './cta-button';
import CtaModal from './cta-modal';
import EditVideoButtonsComponent from './edit-video-buttons';
import EditorWidget from './editor-widget';
import EngagementBar from './engagement-bar';
import SharePageHeaderContent from './header-content';
import JoinTeamBanner from './join-team-banner';
import MobileAppCard from './mobile-app-card';
import MoveModal from './move-modal';
import OverflowMenu from './overflow-menu';
import ProcessErrorModal from './process-error-modal';
import RecordingTimerPaywallModal from './recording-timer-paywall';
import RightPanel from './right-panel';
import SharePageCard from './share-page-card';
import ThumbnailCropper from './thumbnail-cropper';
import TranscriptHeader from './transcript-list/transcript-header';
import TranscriptWrapper from './transcript-list/transcript-wrapper';
import TrimFooter from './trim-footer';
import VideoDescription from './video-description';
import VideoRemoveModal from './video-remove-modal';
import VideoReplyParentIndicator from './video-reply-parent-indicator';
import ViewerVideoButtonsComponent from './viewer-video-buttons';
import WatchLaterButton from './watch-later-button';
import { BOTTOM_CARD_HEIGHT } from './transcript-list/constants';
import {
  getCustomBrandLogo,
  getLoomBrandVisibility,
} from '../../utilities/custom-branding';
import { TEAM_ACCOUNT_TYPES } from '../../../../shared/constants/accountTypes';
import { END_OF_VIDEO_CTA } from '../../../../shared/constants/capabilities';
import {
  ROLLOUT_FILE_ATTACHMENTS,
  ROLLOUT_INTEGRATIONS_LISTING,
  SHOW_MOBILE_APP_CARD,
} from '../../../../shared/constants/featureFlag';
import {
  FAILED,
  TRANSCRIPTION_STATUSES,
} from '../../../../shared/constants/videoTranscript';

import ConfirmationModal from 'components/confirmation-modal';
import PushNotifDialogPrompt from 'components/dialog-prompt';
import FeatureFlaggedComponent from 'components/feature-flag-wrapper';
import InviteModal from 'components/invite-modal';
import Layout from 'components/layout';
import LoomBadge from 'components/loom-badge';
import MediaQuery from 'components/media-query';
import NotificationBlockedPrompt from 'components/notification-blocked-prompt';
import OwnerInfo from 'components/owner-info';
import Scopes from 'components/scopes';
import TitleBar from 'components/share-page-common/title-bar';
import SalesforceModal from 'components/share-video/salesforce-share/salesforce-modal';
import ShareFirstVideoModal from 'components/share-video/share-first-video-modal';
import StatusBar from 'components/status-bar';
import Button from 'components/ui-components/button';
import CreateHintTooltip from 'components/ui-components/create-hint-tooltip';
import ErrorBoundary from 'components/ui-components/error-boundary';
import Modal from 'components/ui-components/modal';
import VideoFrame from 'components/video-frame';
import PermissionModal from 'components/video-player/permission-modal';
import CollaborateModal from 'components/videos-dashboard-ta/collaborate-modal';
import MoveModalTA from 'components/videos-dashboard-ta/move-modal';

import './styles.less';

// added to the document body of the share page to fade everything to black
const TRIM_MODE_CLASS = 'trim-mode-enabled';

// analytics event for notification dialog upselling
const SHARE_VIDEO_PAGE_TITLE = 'Share Video';

// status bar class (bg dark color) for notification dialog upselling
const HAS_STATUS_BAR_CLASS = 'has-status-bar';

const IS_IOS_MOBILE = device.isMobile && device.isIOS;

const InactiveVideoContactOwnerModal = props => {
  const { show, name, pingOwner, ownerPinged, goToLoom } = props;

  const notPingedContent = (
    <>
      <div className="share-video-inactive-video-contact-modal-title">
        This video is currently inactive.
      </div>
      <div className="share-video-inactive-video-contact-modal-content">
        {`We'll let ${name ||
          'the owner'} know you'd like to watch their video.`}
      </div>
      <div className="share-video-inactive-video-contact-modal-action">
        <Button
          onClicked={pingOwner}
          buttonType="rp-primary-2"
          value="Yes! Let them know."
        />
      </div>
    </>
  );

  const pingedContent = (
    <>
      <div className="share-video-inactive-video-contact-modal-title">
        Thanks!
      </div>
      <div className="share-video-inactive-video-contact-modal-content">
        Your request is on its way! 🚀
      </div>
      <div className="share-video-inactive-video-contact-modal-action">
        <Button
          capitalize={false}
          onClicked={goToLoom}
          buttonType="rp-primary-2"
          value="Go to loom.com"
        />
      </div>
    </>
  );

  return (
    <div className="share-video-inactive-video-contact-modal">
      <Modal show={show} dark={true} showClose={false}>
        {ownerPinged ? pingedContent : notPingedContent}
      </Modal>
    </div>
  );
};

const PaywallModals = ({
  showRecordingTimerPaywall,
  video,
  user,
  hasSeenRecordingLimitModal,
  fromRecorderParam,
  recordingLimitParam,
}) => {
  const videoDurationLimit = useWorkspaceLimit(VIDEO_DURATION);

  // If we're coming from a location that's not the recorder (e.g. library, don't show paywalls)
  if (!fromRecorderParam) {
    return null;
  }

  // We show the content limit modal when the content limit was reached but the user was not
  // cut off because of the recording timer limit
  const showContentModal = !recordingLimitParam;

  // If we know the workspace has a recording limit and if the user has reached that limit,
  // show them the recording timer paywall modal (or toast)
  return (
    <>
      {showContentModal && <ContentLimitPaywallModal />}
      {showRecordingTimerPaywall &&
        videoDurationLimit &&
        recordingLimitParam && (
          <RecordingTimerPaywallModal
            video={video}
            user={user}
            renderToast={hasSeenRecordingLimitModal}
            videoDurationLimit={videoDurationLimit}
          />
        )}
    </>
  );
};

class ShareVideo extends Component {
  state = {
    show_create_recording_tooltip: false,
    show_ext_install_bubb: false,
    startTimeParam: getParam('t'),
    video_id: window.location.pathname.replace('/share/', ''),
    ownerPinged: false,
    mobileAppCardIsVisible: true,
    forceFocusTitle: false,
  };

  render() {
    const {
      video_id: videoId,
      show_create_recording_tooltip: showCreateRecordingTooltip,
      startTimeParam,
      forceFocusTitle,
    } = this.state;

    const {
      activeVideoTranscriptId,
      ctaEnabled,
      currentUserIsOwner,
      downloadUrl,
      errorBarShown,
      fetchingVideo,
      focusTitle,
      fromRecorderParam,
      hasSeenRecordingLimitModal,
      hasVideoToolsAccessScope,
      iframeLoaded,
      inTrimMode,
      isLoggedIn,
      isTeamAccount,
      isVideoShareModalOpen,
      needsPermission,
      playerReady,
      recordingLimitParam,
      sfdcModalShow,
      showCollaborateModal,
      showCtaModal,
      showMoveModal,
      showRecordingTimerPaywall,
      showRemoveModal,
      showThumbnailCropper,
      showUploadAttachmentProgressModal,
      showVideoSettings,
      theaterMode,
      toggleTranscriptVisible,
      transcriptStatus,
      transcriptVisible,
      updateVideoNameCreator,
      showControlBar,
      user,
      userCanAccessTranscript,
      userCanEdit,
      userCompletedOnboarding,
      video,
      videoIsSharedWithUser,
      videoIsTeamShared,
      videoPlayerControlsActive,
      videoPlayerHasStarted,
      viewerInsightsActive,
    } = this.props;
    const { video_properties: videoProperties, parentVideoProperties } = video;
    const { isVideoReply } = videoProperties;

    const companyFeatureData = video.company_feature_data || null;

    const showRightPanel =
      !inTrimMode &&
      (transcriptVisible ||
        viewerInsightsActive ||
        showCtaModal ||
        showThumbnailCropper ||
        showVideoSettings);

    const triggerFocusTitle = () => {
      this.setState({ forceFocusTitle: true }, () => {
        // this does not blur the input, but we reset the state so we can
        // trigger focus again (e.g. if the user clicks "Rename" again)
        this.setState({ forceFocusTitle: false });
      });
    };

    const titleBar = (
      <TitleBar
        userCanEdit={userCanEdit && hasVideoToolsAccessScope}
        shouldFocusTitle={currentUserIsOwner && focusTitle}
        forceFocusTitle={currentUserIsOwner && forceFocusTitle}
        video={video}
        onTitleUpdate={updateVideoNameCreator}
      />
    );

    const EditVideoButtons =
      userCanEdit &&
      !inTrimMode &&
      (props => (
        <EditVideoButtonsComponent
          isHidden={
            !currentUserIsOwner &&
            videoPlayerHasStarted &&
            !videoPlayerControlsActive
          }
          onEnterTrimMode={this.handleEnterTrimMode}
          {...props}
        />
      ));

    const ViewerVideoButtons =
      !userCanEdit &&
      (props => (
        <ViewerVideoButtonsComponent
          isHidden={videoPlayerHasStarted && !videoPlayerControlsActive}
          {...props}
        />
      ));

    const shouldDisableTranscript =
      !activeVideoTranscriptId ||
      transcriptStatus === FAILED ||
      !TRANSCRIPTION_STATUSES.includes(transcriptStatus);

    const transcriptIconButton = (
      <IconButton
        altText="Transcript Beta (n)"
        icon={<SvgNotes />}
        onClick={() => this.props.handleToggleTranscriptCreator()}
        isDisabled={shouldDisableTranscript}
      />
    );

    const transcriptButton =
      activeVideoTranscriptId &&
      userCanAccessTranscript &&
      !inTrimMode &&
      transcriptIconButton;

    return (
      <>
        <ShareFirstVideoModal />
        <div className={classNames({ 'is-blurred': isVideoShareModalOpen })}>
          <Layout
            companyFeatureData={companyFeatureData}
            useLegacyNavigation={!isTeamAccount || !userCompletedOnboarding}
            mainContentHasFullWidth
            hasCompactBreadcrumb
          >
            <ErrorBoundary>
              {isLoggedIn && <JoinTeamBanner user={user} video={video} />}

              <div
                className={classNames('share-video-container', {
                  'current-user-is-owner': currentUserIsOwner,
                  'error-bar-shown': errorBarShown,
                  'theater-mode': theaterMode,
                })}
              >
                <div
                  className={classNames('theater-player-container', {
                    'theater-mode': theaterMode,
                    'use-emojis': showControlBar,
                  })}
                />
                <div className={classNames('panels-container')}>
                  <div
                    className={classNames('left-panel', 'new-engagement-bar', {
                      'use-emojis': showControlBar,
                    })}
                  >
                    <VideoFrame
                      EditVideoButtons={EditVideoButtons}
                      ViewerVideoButtons={ViewerVideoButtons}
                      startTime={startTimeParam}
                      videoId={videoId}
                    >
                      {showCtaModal && <CtaModal />}
                      {((!device.isMobile && showControlBar) || inTrimMode) && (
                        <>
                          {inTrimMode && (
                            <ShareVideoControlBar
                              duration={video.video_properties.duration}
                              hasGmailAccount={user.has_gmail_account}
                              isLoggedIn={isLoggedIn}
                              isProtected={video.is_protected}
                              onLeaveTrimMode={this.handleLeaveTrimMode}
                              playerReady={playerReady}
                              video={video}
                            />
                          )}
                          {!inTrimMode && <EngagementBar />}
                        </>
                      )}
                      {showThumbnailCropper && (
                        <ThumbnailCropper videoId={video.id} />
                      )}
                    </VideoFrame>
                    {inTrimMode && (
                      <TrimFooter
                        onRevertClicked={this.handleLeaveTrimMode}
                        video={video}
                      />
                    )}
                    <div className="video-metadata-slideable">
                      {transcriptVisible && (
                        <div
                          className={
                            theaterMode
                              ? 'share-page-card-below-panel-theater'
                              : 'share-page-card-below-panel'
                          }
                        >
                          <SharePageCard
                            height={BOTTOM_CARD_HEIGHT}
                            header={
                              <TranscriptHeader
                                onExit={() => {
                                  toggleTranscriptVisible(false);

                                  analytics.track(TRANSCRIPTION_CLOSE_OUT, {
                                    currentUserIsOwner,
                                    video_id: videoId,
                                    transcript_visible: false,
                                  });
                                }}
                              />
                            }
                          >
                            <TranscriptWrapper />
                          </SharePageCard>
                        </div>
                      )}
                      <div className="below-video">
                        <MediaQuery
                          query={`(max-width: ${SMALL_TABLET_MAX_WIDTH}px)`}
                        >
                          <div className="share-video-title-tools flex">
                            {titleBar}
                            {transcriptButton}
                            <WatchLaterButton />
                            <Spacer right="small" />
                            <OverflowMenu
                              downloadUrl={downloadUrl}
                              triggerFocusTitle={triggerFocusTitle}
                              user={user}
                              video={video}
                            />
                          </div>
                        </MediaQuery>
                        <MediaQuery
                          query={`(min-width: ${LARGE_TABLET_MIN_WIDTH}px)`}
                        >
                          <div className="share-video-title-tools">
                            {titleBar}
                            <MediaQuery
                              query={`(max-width: ${LARGE_TABLET_MAX_WIDTH}px)`}
                            >
                              {transcriptButton}
                            </MediaQuery>
                            <WatchLaterButton />
                          </div>
                        </MediaQuery>
                        <OwnerInfo
                          currentUserIsOwner={currentUserIsOwner}
                          customLogoUrl={getCustomBrandLogo()}
                          date={video.createdAt}
                          name={video.owner_full_name}
                          user={user}
                          userAvatarSrc={
                            video.owner_avatar &&
                            getCloudfrontURI(video.owner_avatar.thumb)
                          }
                          video={video}
                        />
                        <VideoDescription />
                        <MediaQuery
                          query={`(min-width: ${TABLET_MIN_WIDTH}px) and (max-width: ${SMALL_TABLET_MAX_WIDTH}px)`}
                        >
                          {ctaEnabled && (
                            <div className="mt:large">
                              <CustomCtaButton />
                            </div>
                          )}
                        </MediaQuery>
                      </div>
                      {isVideoReply && (
                        <VideoReplyParentIndicator
                          parentProperties={parentVideoProperties}
                        />
                      )}
                      {userCanEdit && (
                        <div className="tablet-actions">
                          <Scopes names={VIDEO_EDIT_OPTIONS_ACCESS}>
                            <EditorWidget
                              onEnterTrimMode={this.handleEnterTrimMode}
                              video={video}
                            />
                          </Scopes>
                        </div>
                      )}
                      {!currentUserIsOwner && (
                        <FeatureFlaggedComponent
                          flag={ROLLOUT_FILE_ATTACHMENTS}
                          activationValues={[true]}
                        >
                          <AttachmentsBar />
                        </FeatureFlaggedComponent>
                      )}
                      {(currentUserIsOwner ||
                        videoIsTeamShared ||
                        videoIsSharedWithUser ||
                        video.comments_enabled) && (
                        <Comments iframeLoaded={iframeLoaded} />
                      )}
                    </div>
                    <ConfirmationModal />
                    {isTeamAccount && showMoveModal ? (
                      <MoveModalTA isSharePage={true} />
                    ) : (
                      <MoveModal />
                    )}
                  </div>
                  {showRightPanel && (
                    <RightPanel
                      onEnterTrimMode={this.handleEnterTrimMode}
                      theaterMode={theaterMode}
                      userCanEdit={userCanEdit}
                      user={user}
                      transcriptVisible={transcriptVisible}
                      onTranscriptExit={() => {
                        toggleTranscriptVisible(false);

                        analytics.track(TRANSCRIPTION_CLOSE_OUT, {
                          currentUserIsOwner,
                          video_id: videoId,
                          transcript_visible: false,
                        });
                      }}
                    />
                  )}
                </div>
                {isLoggedIn && (
                  <>
                    <PushNotifDialogPrompt
                      onAction={this.handleNotificationDialogPromptAction}
                      onClose={this.handleNotificationDialogPromptClose}
                    />
                    <StatusBar
                      onAction={this.handleNotificationStatusBarAction}
                      onClose={this.handleNotificationStatusBarClose}
                    />
                    <NotificationBlockedPrompt />
                  </>
                )}
                <VideoRemoveModal
                  isOpen={showRemoveModal}
                  videoId={videoId}
                  onCloseModal={this.handleLeaveRemoveModal}
                  videoIsTeamShared={videoIsTeamShared}
                  videoIsSharedWithUser={videoIsSharedWithUser}
                />
              </div>
              {showCreateRecordingTooltip && (
                <CreateHintTooltip
                  onClose={() => {
                    this.setState({ show_create_recording_tooltip: false });
                  }}
                />
              )}
              <InviteModal />
              <PaywallModals
                showRecordingTimerPaywall={showRecordingTimerPaywall}
                hasSeenRecordingLimitModal={hasSeenRecordingLimitModal}
                fromRecorderParam={fromRecorderParam}
                recordingLimitParam={recordingLimitParam}
                video={video}
                user={user}
              />
              <ProcessErrorModal />
              <InactiveVideoContactOwnerModal
                goToLoom={this.goToLoom}
                pingOwner={this.pingOwner}
                ownerPinged={this.state.ownerPinged}
                name={video.owner_name}
                show={!currentUserIsOwner && !video.active_status}
              />
              {!fetchingVideo && needsPermission && <PermissionModal />}
              {showUploadAttachmentProgressModal && (
                <AttachmentUploadProgressModal />
              )}
              {showCollaborateModal && <CollaborateModal />}
              <div id="gmail-integration-share-page-placeholder" />
            </ErrorBoundary>
            {getLoomBrandVisibility() && getCustomBrandLogo() && (
              <div className="share-video-loom-badge-section">
                <LoomBadge href="https://www.loom.com" title="Loom homepage" />
              </div>
            )}

            {IS_IOS_MOBILE && this.state.mobileAppCardIsVisible && (
              <FeatureFlaggedComponent
                flag={SHOW_MOBILE_APP_CARD}
                activationValues={[true]}
              >
                <MobileAppCard onCloseClick={this.handleMobileAppCardClose} />
              </FeatureFlaggedComponent>
            )}

            <SharePageHeaderContent
              user={user}
              video={video}
              downloadUrl={downloadUrl}
              currentUserIsOwner={currentUserIsOwner}
              triggerFocusTitle={triggerFocusTitle}
              videoIsTeamShared={videoIsTeamShared}
            />

            <FeatureFlaggedComponent
              flag={ROLLOUT_INTEGRATIONS_LISTING}
              activationValues={[true]}
            >
              <SalesforceModal showModal={sfdcModalShow} />
            </FeatureFlaggedComponent>
          </Layout>
        </div>
      </>
    );
  }

  async componentDidMount() {
    window.addEventListener('message', this.handleShareVideoEvents);
    const {
      currentUserIsOwner,
      fetchGoogleInfoCreator,
      fetchShareVideoDownloadUrlCreator,
      shouldOpenInsights,
      fromRecorderParam,
      isLoggedIn,
      showConfirmationModal,
      subscribeGifReady,
      theaterMode,
      toggleViewerInsightsUI,
      updateVideoCtaShow,
      updateVideoIframeVisibility,
      user = {},
      video = {},
    } = this.props;

    if (theaterMode) {
      this.attachPlayerToTheaterElement();
    }

    if (video.complete) {
      updateVideoIframeVisibility();
      fetchShareVideoDownloadUrlCreator();
    }

    subscribeGifReady(video.id);

    // once the user oauth has been fetched we fetch the google contact info
    // but in case the user already has named video views we don't need to fetch
    // this info since we only require it when we need to invite. In which case
    // the fetch happens when the invite modal pops up.
    if (user.oauth && !user.has_named_video_views) {
      fetchGoogleInfoCreator();
    }

    if (user.capabilities[END_OF_VIDEO_CTA] === true) {
      updateVideoCtaShow(true);
    }

    const installed = await new Promise(resolve => {
      extension.isInstalled(resolve);
    });

    if (
      !installed &&
      (extension.canRunExtension || (!device.isMobile && !device.isChrome))
    ) {
      this.setState({
        show_ext_install_bubb: true,
      });
    }

    analytics.page('Individual Video', {
      url: null,
      is_owner: Boolean(currentUserIsOwner),
      is_logged_in: isLoggedIn,
    });

    this.setState({
      startTimeParam: getParam('t'),
    });

    if (shouldOpenInsights) {
      toggleViewerInsightsUI();
    }

    if (fromRecorderParam) {
      const wasCopied = this.copyLink();

      if (wasCopied) {
        showConfirmationModal(this.getCopyLinkConfirmation());
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { inTrimMode, theaterMode } = this.props;

    // This is the quickest and smoothest way to move a video to a different element
    // and not cause any jiterryness
    if (!prevProps.theaterMode && theaterMode) {
      this.attachPlayerToTheaterElement();
    }

    if (prevProps.theaterMode && !theaterMode) {
      this.removePlayerFromTheaterElement();
    }

    if (inTrimMode != prevProps.inTrimMode) {
      const rootElement = document.documentElement;

      rootElement.className = rootElement.className.replace(
        TRIM_MODE_CLASS,
        ''
      );

      if (inTrimMode) {
        rootElement.className += ` ${TRIM_MODE_CLASS}`;
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleShareVideoEvents);
  }

  attachPlayerToTheaterElement = () => {
    const theaterPlayerContainer = document.querySelector(
      '.theater-player-container'
    );

    theaterPlayerContainer.appendChild(
      document.querySelector('.embed-video-frame-wrapper')
    );

    // TODO: Convert to react functional component and use react hook
    // to trigger getResponsiveVideoWrapperDimensions
    // https://useloom.atlassian.net/projects/LOOM/issues/LOOM-65
    // @paulius005
    this.forceUpdate();
  };

  removePlayerFromTheaterElement = () => {
    const leftPanel = document.querySelector('.left-panel');

    leftPanel.insertBefore(
      document.querySelector('.embed-video-frame-wrapper'),
      leftPanel.firstChild
    );

    // TODO: Convert to react functional component and use react hook
    // to trigger getResponsiveVideoWrapperDimensions
    // https://useloom.atlassian.net/projects/LOOM/issues/LOOM-65
    // @paulius005
    this.forceUpdate();
  };

  pingOwner = () => {
    this.props.sendInactiveVideoOwnerPing();

    this.setState({ ownerPinged: true });
  };

  goToLoom = () => (window.location.pathname = ROOT_PAGE);

  handleLeaveRemoveModal = () => {
    this.props.updateShareVideoShowRemoveModal(false);
  };

  handleEnterTrimMode = () => {
    const {
      id: videoId,
      processing_information: { trim_ranges: trimRanges = [] },
    } = this.props.video;

    this.props.enterTrimModeCreator(trimRanges);

    this.props.updateShareVideoInTrimMode(true);

    analytics.track(ENTERED_TRIM_MODE, {
      id: videoId,
      has_been_trimmed: trimRanges.length > 0,
    });
  };

  handleLeaveTrimMode = () => {
    this.props.updateShareVideoInTrimMode(false);
  };

  handleNotificationDialogPromptAction = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [REQUEST_PUSH_PERMISSIONS]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(PUSH_NOTIFICATION_PROMPT_ACCEPTED);

      this.props.updateNotificationSettings(PUSH_ACTIVATION_SETTINGS);
      this.props.postNotificationSettings(PUSH_ACTIVATION_SETTINGS);
    }
  };

  handleNotificationDialogPromptClose = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [REQUEST_PUSH_PERMISSIONS]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(PUSH_NOTIFICATION_PROMPT_DISMISSED);

      this.props.completeTriggerCreator(REQUEST_PUSH_PERMISSIONS);
    }
  };

  handleNotificationStatusBarAction = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [NEW_ONBOARDING_EXISTING_USER]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(NEW_ONBOARDING_EXISTING_USER_COMPLETE, {
        go_to_use_cases: true,
        from_page: SHARE_VIDEO_PAGE_TITLE,
      });

      this.props.completeTriggerCreator(NEW_ONBOARDING_EXISTING_USER);
      jqueryExt.oneTransitionEnd($('.status-bar'), () => {
        $('#container').removeClass(HAS_STATUS_BAR_CLASS);
      });

      goToNewTab(`${LOOM_URI}${WELCOME}`);
    }
  };

  handleNotificationStatusBarClose = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [NEW_ONBOARDING_EXISTING_USER]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(NEW_ONBOARDING_EXISTING_USER_COMPLETE, {
        go_to_use_cases: false,
        from_page: SHARE_VIDEO_PAGE_TITLE,
      });

      this.props.completeTriggerCreator(NEW_ONBOARDING_EXISTING_USER);
      jqueryExt.oneTransitionEnd($('.status-bar'), () => {
        $('#container').removeClass(HAS_STATUS_BAR_CLASS);
      });
    }
  };

  copyLink = () => {
    return clipboard.copy(this.copyLinkInput);
  };

  handleClickCopyLink = () => {
    anime
      .timeline({
        targets: '.mobile-actions-link-success',
        easing: 'easeInOutQuad',
        duration: 250,
      })
      .add({
        opacity: [0, 1],
      })
      .add({
        delay: 2500,
        opacity: [1, 0],
      });

    this.copyLink();
  };

  handleShareVideoEvents = e => {
    const origin =
      e.origin || (e.originalEvent && e.originalEvent.origin) || '';
    const data = e.data || (e.originalEvent && e.originalEvent.data) || {};

    if (origin.indexOf(LOOM_URI) < 0) {
      return;
    }

    switch (data.type) {
      case EMBED_DIMENSIONS_UPDATE:
        this.props.updateShareVideo({
          ...this.props.video,
          video_properties: {
            ...this.props.video.video_properties,
            height: data.height,
            width: data.width,
          },
        });
        break;
      case EMBED_VIDEO_CORRECT_PASS:
        this.props.updateShareVideoPassword(data.password);
        this.props.fetchShareVideoDownloadUrlCreator();
        break;
      case EMBED_VIDEO_DURATION:
        this.props.updateShareVideo({
          ...this.props.video,
          video_properties: {
            ...this.props.video.video_properties,
            duration: data.duration,
          },
        });
        break;
      case EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED:
        this.props.updateShareVideo({
          ...this.props.video,
          processing_information: data.processing_information,
        });
        this.props.fetchShareVideoDownloadUrlCreator();
        break;
      case EXTENSION_CLICKED:
        this.setState({ show_create_recording_tooltip: false });
        break;
      default:
    }
  };

  handleMobileAppCardClose = () => {
    this.setState({ mobileAppCardIsVisible: false });
  };

  getCopyLinkConfirmation = () => {
    return (
      <div className="flex items:center">
        <img
          src={loomLinkCopiedIconSrc}
          width="40"
          height="40"
          className="mr:small"
        />
        Loom link copied to clipboard!
      </div>
    );
  };
}

const mapStateToProps = state => {
  const {
    current_user_is_owner: currentUserIsOwner,
    download_url: downloadUrl,
    iframe_loaded: iframeLoaded,
    player_ready: playerReady,
    show_remove_modal: showRemoveModal,
    cta_enabled: ctaEnabled,
    video,
    video_is_team_shared: videoIsTeamShared,
    sfdcModalShow,
    transcript_details: { transcription_status: transcriptStatus },
    userCanAccessTranscript,
  } = state.share_video;

  const { download_enabled: downloadEnabled } = video;

  const {
    is_logged_in: isLoggedIn,
    is_logged_in_checked: isLoggedInChecked,
    current,
  } = state.user;

  const { showUploadAttachmentProgressModal } = state.attachments;

  const {
    has_reached_recording_limit: hasSeenRecordingLimitModal,
  } = state.checklist;

  const { triggers } = state.triggers;

  const { in_trim_mode: inTrimMode } = state.trimming;

  const { showing: errorBarShown } = state.error_bar;

  const { cta_flow, thumbnail_flow, video_settings_flow } = state.editor;

  const {
    controlsActive: videoPlayerControlsActive,
    has_started: videoPlayerHasStarted,
    is_fetching: fetchingVideo,
    viewer_needs_permission: needsPermission,
    theater_mode: theaterMode,
    transcriptVisible,
  } = state.video_player;

  const { complete: userCompletedOnboarding } = state.welcome;

  const { showMoveModal } = state.moveModal;

  const videoIsSharedWithUser =
    Object.keys(video.collaboratePermissions).length > 0;
  const isTeamAccount = TEAM_ACCOUNT_TYPES.includes(current.account_type);

  const showRecordingTimerPaywall = hasScope(state, RECORDING_TIMER_PAYWALL);

  const {
    show_collaborate_modal: showCollaborateModal,
  } = state.videos_dashboard;

  const { full_screen: fullScreen } = state.video_player;

  const { isOpen: isVideoShareModalOpen } = state.firstVideoShareModal;

  return {
    activeVideoTranscriptId: video.active_video_transcript_id,
    ctaEnabled,
    currentUserIsOwner,
    downloadUrl: currentUserIsOwner || downloadEnabled ? downloadUrl : null,
    errorBarShown,
    fetchingVideo,
    fullScreen,
    hasSeenRecordingLimitModal,
    hasVideoToolsAccessScope: hasScope(state, VIDEO_TOOLS_ACCESS),
    iframeLoaded,
    inTrimMode,
    isLoggedIn,
    isLoggedInChecked,
    isTeamAccount,
    isVideoShareModalOpen,
    needsPermission,
    playerReady,
    sfdcModalShow,
    showCollaborateModal,
    showCtaModal: cta_flow,
    showMoveModal,
    showRecordingTimerPaywall,
    showRemoveModal,
    showThumbnailCropper: thumbnail_flow,
    showUploadAttachmentProgressModal,
    showVideoSettings: video_settings_flow,
    theaterMode,
    transcriptStatus,
    transcriptVisible,
    triggers,
    showControlBar: selectDrawSharepageControlBar(state),
    user: current,
    userCanAccessTranscript,
    userCanEdit: selectUserCanEditVideo(state),
    userCompletedOnboarding,
    video,
    videoIsSharedWithUser,
    videoIsTeamShared,
    videoPlayerControlsActive,
    videoPlayerHasStarted,
    viewerInsightsActive: viewerInsightsActive(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    completeTriggerCreator: trigger =>
      dispatch(completeTriggerCreator(trigger)),
    enterTrimModeCreator: trimRanges =>
      dispatch(enterTrimModeCreator(trimRanges)),
    fetchGoogleInfoCreator: () => dispatch(fetchGoogleInfoCreator()),
    fetchShareVideoDownloadUrlCreator: () =>
      dispatch(fetchShareVideoDownloadUrlCreator()),
    fetchVideoCreator: videoId => dispatch(fetchVideoCreator(videoId)),
    getFeatureFlag: featureFlag => dispatch(getFeatureFlagCreator(featureFlag)),
    handleToggleTranscriptCreator: () =>
      dispatch(handleToggleTranscriptCreator()),
    postNotificationSettings: notificationSettings =>
      dispatch(
        postNotificationSettings(
          notificationSettings,
          'Re-enabled From Video Page'
        )
      ),
    postVerifyEmail: () => dispatch(postVerifyEmail()),
    sendInactiveVideoOwnerPing: () => dispatch(sendInactiveVideoOwnerPing()),
    showConfirmationModal: message => dispatch(showConfirmationModal(message)),
    showErrorBar: (severity, message) =>
      dispatch(showErrorBar(severity, message)),
    showStatusBar: statusBarParams => dispatch(showStatusBar(statusBarParams)),
    subscribeGifReady: id => dispatch(subscribeToGif(id)),
    toggleTranscriptVisible: transcriptVisible =>
      dispatch(toggleTranscriptVisible(transcriptVisible)),
    toggleViewerInsightsUI: () => dispatch(toggleViewerInsightsUI()),
    updateLoginOrSignUp: logIn => dispatch(updateLoginOrSignUp(logIn)),
    updateNotificationSettings: notificationSettings =>
      dispatch(updateNotificationSettings(notificationSettings)),
    updateShareVideo: video => dispatch(updateShareVideo(video)),
    updateShareVideoInTrimMode: inTrimMode =>
      dispatch(updateShareVideoInTrimMode(inTrimMode)),
    updateShareVideoPassword: password =>
      dispatch(updateShareVideoPassword(password)),
    updateShareVideoShowRemoveModal: show =>
      dispatch(updateShareVideoShowRemoveModal(show)),
    updateVideoCtaShow: show => dispatch(updateVideoCtaShow(show)),
    updateVideoIframeVisibility: isVisible =>
      dispatch(updateVideoIframeVisibility(isVisible)),
    updateVideoNameCreator: name => dispatch(updateVideoNameCreator(name)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareVideo);
